import { Component, Input } from "@angular/core";
import { IPopupContentComponent, MessageBox } from "@geolib/geoappbase-client";
import DxPopup from "devextreme/ui/popup";
import IDataset from "../../IDataset";
import { FormsModule } from "@angular/forms";
import { TranslatePipe } from "@ngx-translate/core";


@Component({
    selector: "tech-reject-dialog",
    templateUrl: "./techRejectDialog.html",
    imports: [FormsModule, TranslatePipe],
})
export default class TechRejectDialog implements IPopupContentComponent {

    @Input() public dataset: IDataset;
    @Input() public techApprove: () => void;
    @Input() public techReject: () => void;

    public techApproveAction: string;

    private popupInstance: DxPopup | undefined;

    public constructor(
        private readonly messageBox: MessageBox,
    ) {
    }

    public onPopupInstanceCreated(popup: DxPopup): void {
        this.popupInstance = popup;
        this.updateButtons();
    }

    private updateButtons(): void {
        if (!this.popupInstance) {
            return;
        }

        const toolbarItems = [this.messageBox.createSecondaryButton("NAVIGATION.ABORT", () => this.cancel())];

        if (this.techApproveAction === "techApprove") {
            toolbarItems.push(this.messageBox.createPrimaryButton(
                "DATASET_DIALOG.BUTTON.OKAY",
                () => this.approve(),
                () => !this.dataset.manualApproveNote,
            ));
        } else if (this.techApproveAction === "techReject") {
            toolbarItems.push(this.messageBox.createPrimaryButton(
                "DATASET_DIALOG.BUTTON.NOT_OKAY",
                () => this.reject(),
            ));
        }

        this.popupInstance.beginUpdate();
        this.popupInstance.instance().option("toolbarItems", toolbarItems);
        this.popupInstance.endUpdate();
    }

    public onTechApproveActionChanged(): void {
        this.updateButtons();
    }

    public onManualApproveNoteChanged(): void {
        this.updateButtons();
    }

    public cancel(): void {
        this.messageBox.hideAll();
    }

    public approve(): void {
        this.techApprove();
        this.cancel();
    }

    public reject(): void {
        this.techReject();
        this.cancel();
    }

}
